import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import orange from '@material-ui/core/colors/orange';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: orange[900],
    color: theme.palette.common.white,
    textAlign: 'center',
    padding: '0 0 3px 0',
    position: 'fixed',
    top: 0,
    left: 'calc( 50% - 100px)',
    zIndex: 10000,
    width: '200px',
    opacity: 0.95,
    borderRadius: '0 0 9px 9px',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.5)',
  }
}));

export default function PreviewNotice() {
  const classes = useStyles();
  return <Box className={classes.root}>Preview mode</Box>;
}
